export default __webpack_public_path__ + "static/media/i.dcfb0f45.svg";